import type { Order } from '@shared-types/common.types';
import type { Enum } from '@shared-types/enum.types';
import type { PlayerEvent } from '@shared-types/match.types';
import { recursiveCall } from '@utilities/fetch';
import { apiKey, matchApiUrl } from '@utilities/WindowContext';

export const EventsFilter = {
  MAIN: 'MAIN',
  GOALS: 'GOALS',
  PENALTY: 'PENALTY',
  CARDS: 'CARDS',
  LINEUP: 'LINEUP',
  RED_CARDS: 'RED_CARDS',
  ALL: 'ALL',
  VAR: 'VAR',
  PHASES: 'PHASES',
  PENALTY_MISSED_REGULAR_TIME: 'PENALTY_MISSED_REGULAR_TIME',
} as const;
export type EventsFilter = Enum<typeof EventsFilter>;

export const fetchMatchEvents = (
  matchId: string,
  params: {
    filter: EventsFilter | EventsFilter[];
    limit?: number;
    offset?: number;
    order?: Order;
  },
  signal?: AbortSignal,
) =>
  recursiveCall<PlayerEvent>(`v5/matches/${matchId}/events`, params, {
    apiUrl: matchApiUrl,
    apiKey,
    signal,
  });

export const fetchPlayerEvents = (
  params: {
    competitionId: string;
    seasonYear: string;
    filter: EventsFilter | EventsFilter[];
    offset?: number;
    limit: number;
    matchId?: string;
    playerIds: string | string[];
    phase?: string;
  },
  signal?: AbortSignal,
) =>
  recursiveCall('v5/events', params, {
    apiUrl: matchApiUrl,
    apiKey,
    signal,
  });
